import { IStop, ILoad, AuctionShipmentPickupOrDelivery } from 'apps/fleet-planner/types'
import { capitalize } from 'utils/capitalize'
import { DISPLAY } from 'constants/display'
import { STOP_TYPE } from '../constants/loads'

export const getStops = (load?: ILoad): IStop[] => {
  const { stops = [] } = load || {}
  return stops
}

export const getFirstStop = (load: ILoad): IStop => {
  const stops = getStops(load)
  return (
    stops.find(stop => stop.stopType === STOP_TYPE.pickup && stop.stopSequence === 1) || stops[0]
  )
}

export const getOtherPickupStop = (load: ILoad): IStop => {
  const stops = getStops(load)
  return (
    stops.find(stop => stop.stopType === STOP_TYPE.pickup && stop.stopSequence > 1) ||
    stops[stops.length]
  )
}

export const getOtherDropoff = (load: ILoad): IStop => {
  const stops = getStops(load)
  return (
    stops.find(
      stop => stop.stopType === STOP_TYPE.dropoff && stop.stopSequence === stops.length - 1
    ) || stops[stops.length]
  )
}

export const getLastStop = (load: ILoad): IStop => {
  const stops = getStops(load)
  return (
    stops.find(stop => stop.stopType === STOP_TYPE.dropoff && stop.stopSequence === stops.length) ||
    stops[stops.length - 1]
  )
}

export const formatCityAndState = (city: string, stateCode: string) => {
  return [capitalize(city), stateCode].filter(Boolean).join(', ') || DISPLAY.na
}

export const formatStop = (stop?: IStop | AuctionShipmentPickupOrDelivery): string => {
  const { city = '', stateCode = '' } = stop || {}
  return formatCityAndState(city, stateCode)
}

export const formatStopFacility = (stop?: IStop): string => {
  const { address } = stop || {}
  const { locality, subdivisionCode } = address || {}
  return [locality, subdivisionCode].filter(Boolean).join(', ') || DISPLAY.na
}

export const getPickupCount = (stops: IStop[] = []): number => {
  const filteredStops = stops.filter(({ stopType }) => stopType === STOP_TYPE.pickup)
  return filteredStops.length
}

export const getDropoffCount = (stops: IStop[] = []): number => {
  const filteredStops = stops.filter(({ stopType }) => stopType === STOP_TYPE.dropoff)
  return filteredStops.length
}

export const getStopNumber = (stop?: IStop, allStops: IStop[] = []): number => {
  const pickupCount = getPickupCount(allStops)
  const dropoffCount = getDropoffCount(allStops)

  const { stopSequence = 1, stopType } = stop || {}
  let stopNumber = 0
  if (stopType === STOP_TYPE.pickup && pickupCount > 1) {
    stopNumber = stopSequence
  } else if (stopType === STOP_TYPE.dropoff && dropoffCount > 1) {
    stopNumber = stopSequence - pickupCount
  }

  return stopNumber
}
